import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/benefits.png'


const _hoisted_1 = { class: "benefits-area pt-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-xl-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "benefits-img" }
const _hoisted_6 = { class: "review mb-minus-53" }
const _hoisted_7 = { class: "review-in" }
const _hoisted_8 = { class: "col-xl-6" }
const _hoisted_9 = { class: "benefits-content" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = ["data-aos-delay"]
const _hoisted_12 = { class: "d-flex benefits-single-item" }
const _hoisted_13 = { class: "flex-shrink-0" }
const _hoisted_14 = { class: "flex-grow-1 ms-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              src: _imports_0,
              alt: "benefits"
            }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "سنوات الخبرة", -1)),
                _createElementVNode("h1", null, _toDisplayString(_ctx.experienceYears) + " سنوات", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-title" }, "المميزات", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-white" }, "مزايا حقيقية لك", -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefits, (benefit, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-lg-6",
                  "data-aos": "fade-up",
                  "data-aos-duration": "1000",
                  "data-aos-delay": 200 + (index % 2) * 100
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("i", {
                        class: _normalizeClass(benefit.icon)
                      }, null, 2)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", null, _toDisplayString(benefit.title), 1),
                      _createElementVNode("p", null, _toDisplayString(benefit.description), 1)
                    ])
                  ])
                ], 8, _hoisted_11))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}